import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const PrimeNumbers = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Prime Numbers</h1>
        <p>Identify prime numbers with this Python project.</p>
        <ImageWithFallback src="/prime_numbers.png" alt="Prime Numbers" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project helps you identify prime numbers using Python code.</p>
        <h2>Download</h2>
        <a href="/Prime_number.py" download>Download Prime_number.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file and input a number to check if it's prime.</p>
      </div>
    </div>
  );
};

export default PrimeNumbers;
